import * as React from "react";

const makeStars = (count, seed = 1) => {
  let s = seed;
  const rand = () => {
    s = (s * 9301 + 49297) % 233280;
    return s / 233280;
  };
  return Array.from({ length: count }, (_, i) => ({
    id: i,
    top: rand() * 100,
    left: rand() * 100,
    size: rand() * 1.8 + 0.6,
    delay: rand() * 5,
    duration: 3 + rand() * 4,
    opacity: 0.25 + rand() * 0.55,
  }));
};

export const StarField = ({ count = 90, className = "" }) => {
  const stars = React.useMemo(() => makeStars(count, 42), [count]);

  return (
    <div
      aria-hidden
      className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
    >
      {stars.map((star) => (
        <span
          key={star.id}
          className="absolute rounded-full bg-foreground animate-twinkle"
          style={{
            top: `${star.top}%`,
            left: `${star.left}%`,
            width: `${star.size}px`,
            height: `${star.size}px`,
            opacity: star.opacity,
            animationDelay: `${star.delay}s`,
            animationDuration: `${star.duration}s`,
          }}
        />
      ))}
    </div>
  );
};
